import { LoginSuccess } from 'entities';

import { typedStorage } from 'utils/storage';

interface AppStorage {
  user: LoginSuccess;

  onboardingShown: boolean;
}

/**
 * Here you'll save data that will be consumed in more than one place
 *
 * If you see that your adding something that's been used on one
 * place, move it locally!
 */
export const store = typedStorage<AppStorage>().init({
  user: '12364695',

  onboardingShown: '023902',
});
